import { useNavigate } from 'react-router-dom';

export default function TechFeatures() {
  const navigate = useNavigate();

  const features = [
    {
      icon: 'ri-cpu-line',
      title: 'Son Teknoloji Teşhis',
      description: 'En güncel teşhis ekipmanları ile hassas arıza tespiti',
      link: '/blog/son-teknoloji-teshis',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantili Hizmet',
      description: 'Tüm işlemlerimizde garanti ve kalite güvencesi',
      link: '/blog/garantili-hizmet',
    },
    {
      icon: 'ri-team-line',
      title: 'Uzman Kadro',
      description: 'Sertifikalı ve deneyimli teknisyen ekibimiz',
      link: '/blog/uzman-kadro',
    },
    {
      icon: 'ri-time-line',
      title: 'Hızlı Servis',
      description: 'Aynı gün teslimat ve acil tamir hizmetleri',
      link: '/blog/hizli-servis',
    },
    {
      icon: 'ri-vip-crown-line',
      title: 'Üst Segment Uzmanlığı',
      description: 'Mercedes, BMW, Audi, Porsche gibi premium araçlar için özel hizmet',
      link: '/blog/ust-segment-uzmanligi',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-sans text-3xl sm:text-4xl lg:text-5xl font-light text-gray-900 mb-4">
            Teknoloji ve Uzmanlık
          </h2>
          <p className="font-sans text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Modern ekipmanlarımız ve uzman kadromuzla aracınıza en iyi hizmeti sunuyoruz
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <button
              key={index}
              onClick={() => navigate(feature.link)}
              className="bg-white border border-gray-200 p-6 sm:p-8 hover:border-accent-gold transition-all duration-300 group text-left cursor-pointer"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${feature.icon} text-3xl sm:text-4xl text-accent-gold group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              <h3 className="font-sans text-lg sm:text-xl font-semibold text-gray-900 mb-3 group-hover:text-accent-gold transition-colors">
                {feature.title}
              </h3>
              <p className="font-sans text-sm sm:text-base text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}